import { AgGridTable } from 'components/AgGrid/AgGridTable';
import type { BimPriceLevelEnum, WorkOrderStatusEnum } from 'gql/graphql';
import { Loader } from 'uikit';

import type { GridReadyEvent } from 'ag-grid-community';
import type { AgGridReact } from 'ag-grid-react';
import type { ForwardedRef } from 'react';
import { forwardRef, useCallback } from 'react';

import { useBimWorkOrderTotalsVersionTable, useBimWorkOrderTotalVersionColumns } from './hooks';

const defaultColDef = {
    resizable: true,
    wrapHeaderText: true,
    cellClass: 'ag-right-aligned-cell',
};

const tableLoadingComponent = () => <Loader />;

interface IBimWorkOrderTotalsTable {
    workOrderVersionId: number;
    constructionTypeId: number | undefined;
    bimTotalsChapter: string;
    workOrderStatus: WorkOrderStatusEnum;
    hasInProgress: boolean;
    isFrameContract: boolean;
    priceLevel: BimPriceLevelEnum | undefined;
}

export const BimWorkOrderTotalsVersionTable = forwardRef(
    (
        {
            bimTotalsChapter,
            workOrderVersionId,
            constructionTypeId,
            workOrderStatus,
            hasInProgress,
            isFrameContract,
            priceLevel,
        }: IBimWorkOrderTotalsTable,
        ref: ForwardedRef<AgGridReact<any>>,
    ) => {
        const { tableData } = useBimWorkOrderTotalsVersionTable({
            bimTotalsChapter,
            workOrderVersionId,
            constructionTypeId,
            priceLevel,
        });

        const { columns, bimTotalsTableRowClassRules } = useBimWorkOrderTotalVersionColumns({
            workOrderStatus,
            hasInProgress,
            isFrameContract,
        });

        const onGridReady = useCallback((event: GridReadyEvent) => {
            event.api.sizeColumnsToFit();
        }, []);

        return (
            <div className="ag-theme-alpine BimWorkOrderPrice customHeaderColor">
                <AgGridTable
                    rowData={tableData}
                    columnDefs={columns}
                    animateRows
                    overlayNoRowsTemplate="Нет данных"
                    loadingOverlayComponent={tableLoadingComponent}
                    defaultColDef={defaultColDef}
                    ref={ref}
                    rowClassRules={bimTotalsTableRowClassRules}
                    suppressDragLeaveHidesColumns
                    onGridReady={onGridReady}
                />
            </div>
        );
    },
);

BimWorkOrderTotalsVersionTable.displayName = 'BimWorkOrderTotalsVersionTable';
